module.exports = "<div class=\"scanner-component\">\r\n    <div id=\"scanner\"></div>\r\n</div>";